import { css } from '@emotion/react';
import { useState } from 'react';
import { AiOutlineCloudUpload } from 'react-icons/ai';
import { FiUser } from 'react-icons/fi';
import { MdKeyboardArrowRight, MdManageAccounts } from 'react-icons/md';
import { PiKeyFill } from 'react-icons/pi';
import { TbTrash } from 'react-icons/tb';
import { BeatLoader } from 'react-spinners';
import { Input } from '../../components/Input';
import { PageHeader } from '../../components/page-header';
import { useAccount } from '../../hooks/useAccount';
import { useAuth } from '../../hooks/useAuth';
import { formatPhone } from '../../utils/formatter';
import { PasswordChangeModal } from './password-change-modal';

import './styles.css';
import { ManageAccessModal } from './manage-access-modal/ManageAccessModal';
import { UpdateAccessModal } from './update-access-modal/UpdateAccessModal';
import { useCompanyUser } from '../../hooks/useCompanyUser';
import { toast } from 'react-toastify';
import { getApiErrorMessage } from '../../utils/getApiErrorMessage';
import { CreateAccessModal } from './create-access-modal/CreateAccessModal';
import { CloseAccountModal } from './close-account-modal/CloseAccountModal';

export function Settings() {
  const { user } = useAuth();
  const { editAvatar, deleteAvatar } = useAccount();

  const [loader, setLoader] = useState(false);

  const [passwordChangeModal, setPasswordChangeModal] = useState(false);
  const [manageAccessModal, setManageAccessModal] = useState(false);
  const [updateAccessModal, setUpdateAccessModal] = useState(false);
  const [createAccessModal, setCreateAccessModal] = useState(false);
  const [closeAccountModal, setCloseAccountModal] = useState(false);

  const {
    companyUsers,
    listCompanyUser,
    createCompanyUser,
    editCompanyUser,
    editCompanyUserStatus,
    deleteCompanyUser,
    selectedCompanyUser,
    setSelectedCompanyUser,
    companyUserLoading,
  } = useCompanyUser();

  const handleAvatarChange = async (e) => {
    setLoader(true);

    if (e.target.files) {
      const file = e.target.files[0];

      await editAvatar(file);

      setLoader(false);
    } else {
      setLoader(false);
    }
  };

  const handleDeleteAvatar = async () => {
    setLoader(true);

    await deleteAvatar()
      .then(() => {
        setLoader(false);
      })
      .catch(() => {
        setLoader(true);
      });
  };

  const handleOpenUpdateModal = (access) => {
    setSelectedCompanyUser(access);
    setManageAccessModal(false);
    setUpdateAccessModal(true);
  }

  const handleUpdateCompanyUser = async (data) => {
    try {
      await editCompanyUser(data);
      toast.success('Usuário atualizado com sucesso!');
      listCompanyUser();
      setUpdateAccessModal(false);
      setManageAccessModal(true);
    } catch (err) {
      toast.error(getApiErrorMessage(err, 'Erro ao atualizar usuário'));
    }
  }

  const handleUpdateCompanyUserStatus = async (data) => {
    try {
      await editCompanyUserStatus(data);
      toast.success('Usuário atualizado com sucesso!');
      listCompanyUser();
      setUpdateAccessModal(false);
      setManageAccessModal(true);
    } catch (err) {
      toast.error(getApiErrorMessage(err, 'Erro ao atualizar status do usuário'));
    }
  }

  const handleDeleteCompanyUser = () => {
    try {
      deleteCompanyUser();
      toast.success('Usuário deletado com sucesso!');
      listCompanyUser();
      setUpdateAccessModal(false);
      setManageAccessModal(true);
    } catch (err) {
      toast.error(getApiErrorMessage(err, 'Erro ao deletar usuário'));
    }
  }

  const handleCreateCompanyUser = async (e) => {
    try {
      await createCompanyUser(e);
      toast.success('Usuário criado com sucesso!');
      listCompanyUser();
      setCreateAccessModal(false);
      setManageAccessModal(true);
    } catch (err) {
      toast.error(getApiErrorMessage(err, 'Erro ao criar usuário'));
    }
  }

  const override = css`
    display: flex;
    margin: 0 auto;
    border-color: red;
  `;

  const getAvatar = () => {
    const isMainUser = user?.isMainAccess;

    if (isMainUser && user?.avatar) {
      return <img src={user?.avatar?.url} alt="" />
    }
    if (!isMainUser && user?.companyUser?.avatar) {
      return <img src={user?.companyUser?.avatar?.url} alt="" />;
    }

    return <FiUser size={40} />;
  };

  return (
    <>
      <div className="settings-container">
        <div className="settings-header">
          <PageHeader
            title="Configurações"
            pages={[{ name: 'Configurações', link: '' }]}
          />
        </div>

        <div className="settings-section">
          <div className="settings-section-title">
            <span>Foto de Perfil</span>
            <MdKeyboardArrowRight size={24} />
          </div>

          <div className="settings-avatar-content">
            <div className="settigs-avatar">
              {loader ? (
                <BeatLoader
                  color="white"
                  loading={loader}
                  css={override}
                  size={10}
                />
              ) : (
                <>
                  {getAvatar()}
                </>
              )}
            </div>

            <div className="avatar-input-file">
              <label htmlFor="new-avatar" className="settings-avatar-button">
                <AiOutlineCloudUpload size={16} />
                Enviar nova Foto
              </label>
              <input
                type="file"
                id="new-avatar"
                onChange={handleAvatarChange}
                accept="image/png,image/jpeg,image/webp"
              />
            </div>

            <button
              className="settings-avatar-button button-without-bg"
              onClick={handleDeleteAvatar}
            >
              <TbTrash size={16} />
              Apagar foto
            </button>
          </div>
        </div>

        <div className="settings-content">
          <div className="settings-section">
            <div className="settings-section-title">
              <span>Informações de Contato</span>
              <MdKeyboardArrowRight size={24} />
            </div>

            <form className="settings-contanct-content">
              <Input
                type="email"
                label="Email"
                value={user?.companyUser?.mail || user.mail}
                placeholder="fuladodetal@gmail.com"
                disabled
              />

              <Input
                type="email"
                label="Telefone"
                value={formatPhone(String(user?.companyUser?.phone || user.phoneNumber))}
                placeholder="(21) 98765-4321"
                disabled
              />
            </form>
          </div>

          {
            user.isMainAccess &&
            <div className="settings-section without-border">
              <div className="settings-section-title">
                <span>Senha</span>
                <MdKeyboardArrowRight size={24} />
              </div>

              <div className="settings-contanct-content">
                <button
                  className="change-password-button"
                  onClick={() => setPasswordChangeModal(true)}
                >
                  <PiKeyFill size={16} />
                  Alterar Senha
                </button>
              </div>
            </div>
          }
          {
            user.isMainAccess && user.type === '1' &&
            <div className="settings-section without-border">
              <div className="settings-section-title">
                <span>Acessos</span>
                <MdKeyboardArrowRight size={24} />
              </div>

              <div className="settings-contanct-content">
                <button
                  className="access-button"
                  onClick={() => setManageAccessModal(true)}
                >
                  <MdManageAccounts size={16} />
                  Seus Acessos
                </button>
              </div>
            </div>
          }
          {
            user.isMainAccess &&
            <div className="settings-section without-border">
              <div className="settings-section-title">
                <span>Encerrar Conta</span>
                <MdKeyboardArrowRight size={24} />
              </div>

              <div className="settings-contanct-content">
                <button
                  className="access-button"
                  onClick={() => setCloseAccountModal(true)}
                >
                  <MdManageAccounts size={16} />
                  Fechar Conta
                </button>
              </div>
            </div>
          }
        </div>
      </div>

      <PasswordChangeModal
        isOpen={passwordChangeModal}
        setPasswordChangeModal={setPasswordChangeModal}
      />

      <ManageAccessModal
        isOpen={manageAccessModal}
        companyUsers={companyUsers}
        setManageAccessModal={setManageAccessModal}
        setCreateAccessModal={setCreateAccessModal}
        handleOpenUpdateModal={handleOpenUpdateModal}
        listCompanyUser={listCompanyUser}
      />

      <UpdateAccessModal
        isOpen={updateAccessModal}
        selectedAccess={selectedCompanyUser}
        setUpdateAccessModal={setUpdateAccessModal}
        updateCompanyUser={handleUpdateCompanyUser}
        updateCompanyUserStatus={handleUpdateCompanyUserStatus}
        deleteCompanyUser={handleDeleteCompanyUser}
        companyUserLoading={companyUserLoading}
      />

      <CreateAccessModal
        isOpen={createAccessModal}
        setCreateAccessModal={setCreateAccessModal}
        createCompanyUser={handleCreateCompanyUser}
        companyUserLoading={companyUserLoading}
      />

      <CloseAccountModal
        isOpen={closeAccountModal}
        setCloseAccountModal={setCloseAccountModal}
      />
    </>
  );
}
